import React from 'react';
import './Helpline.css'

const Helpline = () => {
    return (
        <div className="help-container">
            <div>
                <h1>Empire Hospital Emergency Helpline Support.</h1>
                <p>A patient priority first so that we are here on 24 hours non-stop service by our helplines</p>
                <p>only one call enough for us to  rescue a patient. whth in 30 minutes ambulance at your door.</p>
                <p>so without any tenson dial our number if you in critical situation</p>
                <h2>PHONE</h2>
                <p>0123532******</p>
                <p>0123533******</p>
                <p>0123535******</p>
                <p>01235372******</p>
                <h2>Email</h2>
                <p>Empire-Hospital@gmail.com</p>
            </div>

        </div>
    );
};

export default Helpline;